var n=function(c){return c.DESC="desc",c.ASC="asc",c}({});export{n as CrudSortOperator};